import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const services = [
    { id: 1, title: "Custom Web Development", category: "Custom Software Development", difficulty: "Beginner", description: "Build tailored web applications for your business needs.", takenBy: 150 },
    { id: 2, title: "Mobile App Development", category: "Custom Software Development", difficulty: "Intermediate", description: "Develop custom mobile apps for Android and iOS platforms.", takenBy: 95 },
    { id: 3, title: "Enterprise Software Solutions", category: "Custom Software Development", difficulty: "Advanced", description: "Design and develop enterprise-level software systems.", takenBy: 120 },
    { id: 4, title: "CRM System Customization", category: "Custom Software Development", difficulty: "Intermediate", description: "Customize and implement CRM systems tailored to your needs.", takenBy: 75 },
    { id: 5, title: "E-Commerce Solutions", category: "Custom Software Development", difficulty: "Intermediate", description: "Build scalable e-commerce platforms with unique features.", takenBy: 130 },
    { id: 6, title: "Cloud-Based Software Solutions", category: "Custom Software Development", difficulty: "Advanced", description: "Develop and deploy custom cloud solutions.", takenBy: 110 },
    { id: 7, title: "Business Intelligence Solutions", category: "Custom Software Development", difficulty: "Advanced", description: "Create custom BI dashboards and analytics tools.", takenBy: 85 },
    { id: 8, title: "Automation Tools Development", category: "Custom Software Development", difficulty: "Beginner", description: "Automate repetitive tasks and workflows for efficiency.", takenBy: 105 },
];

const pageSize = 4;

function CustomSoftwareDevelopment() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredServices = services.filter(service => service.difficulty === activeTab);
    const paginatedServices = filteredServices.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Custom Software Development</Title>
                <Paragraph>Explore our range of custom software development services to meet the unique needs of your business, from web and mobile apps to enterprise-level solutions.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedServices.map((service) => (
                        <Col xs={24} sm={12} md={6} key={service.id}>
                            <Card hoverable>
                                <Title level={5}>{service.title}</Title>
                                <Tag color="blue">{service.category}</Tag>
                                <Tag color={service.difficulty === "Beginner" ? "green" : service.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {service.difficulty}
                                </Tag>
                                <Paragraph>{service.description}</Paragraph>
                                <Paragraph><UserOutlined /> {service.takenBy} projects delivered</Paragraph>
                                <Button type="primary">Start Project</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredServices.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default CustomSoftwareDevelopment;
